<mat-form-field>
    <input
        #search
        matInput
        placeholder="Szukaj po nazwie albo numerze EAN"
        [formControl]="searchForm"
    />
    <mat-icon matPrefix>search</mat-icon>
</mat-form-field>

<div class="results">
    <ng-container *ngIf="products$ | async as products">
        <rm-retail-media-products-result
            *ngFor="let product of products"
            [product]="product"
            [isSelected]="isSelected(product)"
            (onSelect)="onSelect.emit($event)"
            (onRemove)="onRemove.emit($event)"
        />
        <span
            class="limit"
            *ngIf="products.length"
        >Wyszukaliśmy {{products.length}} najlepiej dopasowanych produktów. Zawęź wyszukiwanie aby znaleźć więcej.</span>
        <span
            class="empty"
            *ngIf="!products.length && searchForm.value"
        >Nie udało się znaleźć tego czego szukasz</span>
        <span
            class="empty"
            *ngIf="!products.length && !searchForm.value"
        >Wprowadź nazwę lub numer EAN produktu, aby go znaleźć w katalogu</span>
    </ng-container>

    <app-loader *ngIf="loading" color="primary" />
</div>
